import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Waking up early - the best way to waste the day",
  "description": "",
  "published": "2012-09-06T00:00:00.000Z",
  "redirect_from": ["/blog/waking-up-early-the-best-way-to-waste-the-day/swizec/5237"],
  "categories": "Early to Bed, Franklin, Health, Morning, Uncategorized, Waking up early",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/09/nothingproductiveallday.gif",
        "alt": "How rising early makes me feel",
        "title": "How rising early makes me feel"
      }}></img></p>
    <p>{`There are roughly three types of people in the world:`}</p>
    <ol>
      <li parentName="ol">{`Those who are nightowls`}</li>
      <li parentName="ol">{`Those who are morning larks`}</li>
      <li parentName="ol">{`Those who wake up so early they might well be nightowls`}</li>
    </ol>
    <p>{`While I've yet to meet any type 3 human in person, they are quite vocal on the internets. Rising anywhere from 4am to as early as 1 or 2am ... are these superhuman persons nightowls or morning larks? It's hard to say.`}</p>
    <p>{`I'd wager the real mornings larks are those waking up at 6 and 7am `}<em parentName="p">{`and liking it.`}</em>{` Many have been forced into the schedule by other morning larks, but some do like it. Others are left to feel like the dirty slobs of this world. Waking up at 10am!? Are you a rockstar? No. Then you're a bum!`}</p>
    <blockquote>
      <p parentName="blockquote">{`Early to bed and early to rise makes a man healthy, wealthy, and wise.`}</p>
      <p parentName="blockquote">{`~ Mr. Franklin`}</p>
    </blockquote>
    <p>{`The main advantage supposedly being that you can get more out of the day, make it magically longer and just all 'round better spent. All early risers seem to agree on this one. `}<em parentName="p">{`You're wasting most of the day getting up at 10am, you slob!`}</em>{` they'll say, then feel smug about their `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Waking_up_early",
        "title": "Waking up early"
      }}>{`early rising`}</a>{` and how much longer days they're having. Smug as a bun.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Only a white man would think cutting the end off a blanket and stitching it to the other end, will make the blanket longer.`}</p>
      <p parentName="blockquote">{`~A Smart Native American`}</p>
    </blockquote>
    <p>{`Okay that one is from a meme about day-time-savings, but the point still stands. Everybody gets the same twenty-four hours minus some sleep. You can't escape that.`}</p>
    <p>{`So, really, what benefit can there possibly be from rising early? For me it's quite the opposite.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/09/notinventedhere.png",
        "alt": "A frame from today's Not Invented Here",
        "title": "A frame from today's Not Invented Here"
      }}></img></p>
    <p>{`Lately I've been waking up early on some days, mostly because of exams. Super early at times - 4am, so you have an all-nighter without having an all-nighter - other times a much tamer 7am, just because an exam happens early in the day.`}</p>
    <p>{`On all those days I've noticed a soul crushing lack of energy despite getting the usual amount and quality of sleep. Coming home from the exam I am left lethargic. Feeling like a wet rag. Barely able to muster the energy fro mindless internet browsing.`}</p>
    <p>{`Mostly I will just stare at the bright screen like a doped out fly. Click click. Tap tap. Click.`}</p>
    <p>{`Occasionally I drool.`}</p>
    <p>{`Therefore, a simple set of questions for all early risers: How do you avoid the soul crushing energy slump between 1pm and midnight? Does it just take a few months to get used to and then you're fine?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://inspiredidiot.wordpress.com/2012/09/06/the-secret-productivity-tool/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/110492815_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://inspiredidiot.wordpress.com/2012/09/06/the-secret-productivity-tool/"
        }}>{`The Secret Productivity Tool?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mytechnologyworld9.blogspot.com/2012/08/health-benefits-of-being-early-riser.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_122_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://mytechnologyworld9.blogspot.com/2012/08/health-benefits-of-being-early-riser.html"
        }}>{`Health Benefits Of Being An Early Riser`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://makeyourmarkonlife.wordpress.com/2012/08/21/ways-to-become-an-early-riser/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/108088656_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://makeyourmarkonlife.wordpress.com/2012/08/21/ways-to-become-an-early-riser/"
        }}>{`Ways to become an early riser`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://dreamhuntress.wordpress.com/2012/07/28/early-to-bed-early-to-rise/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/103128170_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://dreamhuntress.wordpress.com/2012/07/28/early-to-bed-early-to-rise/"
        }}>{`Early to bed, early to rise...`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://harikrishnamurthy.wordpress.com/2012/07/31/benefits-of-early-rising/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/103743589_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://harikrishnamurthy.wordpress.com/2012/07/31/benefits-of-early-rising/"
        }}>{`Benefits of early rising`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=3bf0a351-4f26-4517-aec7-3ef9a9f1bdc8",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      